import React, { useEffect, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import DataTable from '../../../Common/DataTable';
import ComponentDeleteModal from '../../../Common/DeleteModal/ComponentDeleteModal';
import { exportToExcelData } from '../../../Common/PageHeader/helper';
import { TableColumns } from './utils/DataCustomerHeaderCell';
import { RecommendationTextData } from './utils/TypeRecommendationTexts';
import ComponentAddTextModal from './addTextModal';
import { RootState } from '../../../redux/rootState';
import { setLoader } from '../../../redux/loaderSlice';
import {
  getRecommendationCodesData,
  onDeleteRecommendationCodes, onFailureCreateRecommendationCodesData,
  onSuccessDeleteRecommendationCodes,
} from '../recommendationCodes/Redux/sliceRecommendationCodes';
import { DEFAULT_VALUE_TEXTS } from '../constant';
import { formatTableData } from './helper';
import { RecommendationCodesExcelData } from '../recommendationCodes/utils/TypeRecommendationCodes';
import { defaultPageSize } from '../../../utils/Constant';

export default function RecommendationTextScreen() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [rowId, setRowId] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const {
    isLoading, recommendationCodesData, codeCreated, codeDeleted,
  } = useSelector((state: RootState) => state.RecommendationCodesReducer);

  const handleDelete = (id: string) => {
    setDeleteModal(true);
    setSelectedId(id);
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleDeleteModal = () => {
    dispatch(onDeleteRecommendationCodes(selectedId));
  };

  const handleEdit = (id: string) => {
    setShowAddModal(true);
    setRowId(id);
  };

  const handleData = () => {
    const payload = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
      type: DEFAULT_VALUE_TEXTS,
    };
    dispatch(getRecommendationCodesData(payload));
  };

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  const excelData = useMemo(() => recommendationCodesData?.Data?.map((item:RecommendationCodesExcelData) => {
    const transformedDataItems = {
      Description: item?.Description,
    };
    return transformedDataItems;
  }), [recommendationCodesData]);

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: excelData,
      },
      'Recommendation_Text',
    );
  };

  const handleButtonClick = () => {
    setShowAddModal(true);
  };

  useEffect(() => {
    if (codeCreated || codeDeleted) {
      setShowAddModal(false);
      setDeleteModal(false);
      handleData();
      dispatch(onFailureCreateRecommendationCodesData(false));
      dispatch(onSuccessDeleteRecommendationCodes(false));
      setRowId('');
    }
  }, [codeCreated, codeDeleted]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <ComponentPageHeader subHeading="RECOMMENDATION TEXT" downloadExcel={downloadExcel} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
          <DataTable<RecommendationTextData>
            handleButtonClick={handleButtonClick}
            data={recommendationCodesData?.Data?.length > 0 ? formatTableData(recommendationCodesData?.Data) : []}
            columns={TableColumns}
            totalRecords={recommendationCodesData?.TotalRecords}
            buttonText="Add"
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            searchQuery={searchQuery}
            setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
            sortCol={sortCol}
            setSortCol={(e) => { setSortCol(e); setPage(1); }}
            sortDir={sortDir}
            setSortDir={(e) => { setSortDir(e); setPage(1); }}
            handleData={handleData}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
            handleDataFromComponent
          />
        </Grid>
      </Grid>
      <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setDeleteModal(false)}
        handleDelete={handleDeleteModal}
      />
      <ComponentAddTextModal
        rowId={rowId}
        show={showAddModal}
        setOpenFrom={() => {
          setShowAddModal(false);
          setRowId('');
        }}
      />
    </>
  );
}
